import { render, staticRenderFns } from "./upgrade_test_check.vue?vue&type=template&id=222d4975&scoped=true&"
import script from "./upgrade_test_check.vue?vue&type=script&lang=js&"
export * from "./upgrade_test_check.vue?vue&type=script&lang=js&"
import style0 from "./upgrade_test_check.vue?vue&type=style&index=0&id=222d4975&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d4975",
  null
  
)

export default component.exports